import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import { PrimeNGConfig } from 'primeng/api';
import {Contact, ContactService} from '@app/_components/contact';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-import-contact',
    templateUrl: './import-contact.component.html',
    styleUrls: ['./import-contact.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ImportContactComponent implements OnInit {
	private tagsSelected: any;
	willDownload: boolean;
	private excelContacts: any = [];

	constructor(
		private primengConfig: PrimeNGConfig,
		private contactService: ContactService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title;
	}

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	importContactId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

	}


	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			if (!this.tagsSelected){
				this.tagsSelected = [];
			}
			this.form1.value.tags = this.tagsSelected;
			const contacts: Contact[] = [];

			if(this.form1.value.importMails != null) {
				this.form1.value.importMails.forEach(email => {
					const contact = new Contact();
					contact.emailAddress = email;
					contacts.push(contact);
				});
			}

			if(this.excelContacts != null) {
				this.excelContacts.forEach(email => {
					contacts.push(email);
				});
			}

			this.form1.value.contactAPIList = contacts;
			this.form1.value.tagJoinAPIList = this.tagsSelected;
			this.contactService.importContacts(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact imported successful' });
						this.doAdd.emit(null);
					},
					(err: any) => {
						console.log('importContact-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			importMails: [],
		});
	}

	validateEmailAddress(event: any, elementData: any) {
		let eventdata = event.value.trim();
		let emails = [];
		let seperator ;
		if (eventdata.indexOf(' ') > 0 ){
			seperator = ' ';
			emails = eventdata.split(' ');
			elementData.pop();
		}
		else if (eventdata.indexOf(',') > 0 ){
			seperator = ',';
			emails = eventdata.split(',');
			elementData.pop();
		}
		else if (eventdata.indexOf(';') > 0 ){
			seperator = ';';
			emails = eventdata.split(';');
			elementData.pop();
		}
		if (emails.length === 0 && !this.validEMail(eventdata)){
			elementData.pop();
			return;
		}

		emails.forEach( mail => {
			if (this.validEMail(mail)) {
				elementData.push(mail);
			}
			else{
				this.form1.value.importMails.pop();
			}
		});
	}
	validEMail(email: string){
		let regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regEx.test(email);
	}

	onKeyDown(event: KeyboardEvent) {
		if (event.key === ',' || event.key === ';' || event.key === ' ') {
			event.preventDefault();
			const element = event.target as HTMLElement;
			element.blur();
			element.focus();
		}
	}

	updateTagSelected($event: any) {
		this.tagsSelected = $event;
	}
	onFileChange(ev) {
		let workBook = null;
		let jsonData = null;
		const reader = new FileReader();
		const file = ev.target.files[0];
		reader.onload = (event) => {
			const data = reader.result;
			workBook = XLSX.read(data, { type: 'binary' });
			jsonData = workBook.SheetNames.reduce((initial, name) => {
				const sheet = workBook.Sheets[name];
				initial[name] = XLSX.utils.sheet_to_json(sheet);
				return initial;
			}, {});
			this.setToJSONArray(jsonData.data);
			const dataString = JSON.stringify(jsonData);
			document.getElementById('output').innerHTML = jsonData.data.length + ' records selected';
			this.setDownload(dataString);
		};
		reader.readAsBinaryString(file);
	}


	setDownload(data) {
		this.willDownload = true;
		setTimeout(() => {
			const el = document.querySelector("#download");
			el.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
			el.setAttribute("download", 'xlsxtojson.json');
		}, 1000);
	}

	private setToJSONArray(data) {
		data.forEach(json => {
			const contact = new Contact();
			contact.emailAddress = json.emailAddress;
			contact.fullName = json.fullName;
			contact.firstName = json.firstName;
			contact.lastName = json.lastName;
			contact.subjAdrStreet = json.subjAdrStreet;
			contact.mobilePhone = json.mobilePhone;
      contact.phone2 = json.phone2;
      contact.mailAdrStreet = json.mailAdrStreet;
      contact.mailAdrStreet2 = json.mailAdrStreet2;
      contact.mailAdrCity = json.mailAdrCity;
      contact.mailAdrState = json.mailAdrState;
      contact.mailAdrCountry = json.mailAdrCountry;
      contact.mailAdrPostalCode = json.mailAdrPostalCode;
      this.excelContacts.push(contact);
		});
	}
}
